<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
        @if (showAvatar && user.avatar) {
            <img class="h-7 w-7 rounded-full" [src]="user.avatar" />
        }
        @if (!showAvatar || !user.avatar) {
            <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        }
        <span
        class="absolute bottom-0 right-0 h-2 w-2 rounded-full"
        [ngClass]="{
            'mb-px mr-px': !showAvatar || !user.avatar,
            'bg-green-500': user.status === 'online',
            'bg-amber-500': user.status === 'away',
            'bg-red-500': user.status === 'busy',
            'bg-gray-400': user.status === 'not-visible',
        }"
    ></span>
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none space-y-1">
            <span class="mt text-md font-medium">{{user.name}}</span>
            <span class="mt text-md font-medium text-gray-400">{{user.email}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="navigateToUserSettings()">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Perfil</span>
    </button>
    @if(rol === 'Manager')
    {
        <button mat-menu-item (click)="settings()">
            <mat-icon [svgIcon]="'heroicons_outline:cog'"></mat-icon>
            <span>Configuraciones</span>
        </button>
    }
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
        <span>Cerrar Sesión</span>
    </button>
</mat-menu>